import { userPageUrlApi } from 'api'

const state = {
  urls: []
}

const getters = {
  urls: state => state.urls
}

const actions = {
  getUrls ({ commit }) {
    userPageUrlApi.getList().then(resp => {
      commit('setUrls', resp.data)
    })
  },
  addUrl ({ commit }, url) {
    userPageUrlApi.add(url.pageNumber, url.title, url.url).then(resp => {
      commit('addUrl', resp.data)
    })
  },
  deleteUrl ({ commit }, id) {
    userPageUrlApi.delete(id).then(resp => {
      commit('deleteUrl', id)
    })
  }
}

const mutations = {
  setUrls (state, urls) {
    state.urls = urls
  },
  addUrl (state, url) {
    state.urls.push(url)
  },
  deleteUrl (state, id) {
    state.urls.splice(state.urls.findIndex(u => u.id === id), 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
